import { InvalidFieldError } from '../../validation/errors/invalid-field-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'
import { type ValidateZipAdapter } from '../../validation/protocols/validate-zip-adapter'

export class ZipValidation implements FieldValidation {
  private readonly validateZipAdapter: ValidateZipAdapter
  readonly field: string

  constructor (field: string, validateZipAdapter: ValidateZipAdapter) {
    this.field = field
    this.validateZipAdapter = validateZipAdapter
  }

  validate (value: string): Error | null {
    const isValid = this.validateZipAdapter.validate(value)
    return isValid ? null : new InvalidFieldError('CEP')
  }
}
